import createCrudModule from 'vuex-crud';
import API from '@/api';

export default createCrudModule({
  resource: 'confession',
  client: API.$http
});
